<mat-list [disableRipple]="true" *ngIf="alarm">
  <ng-template [ngIf]="suspectPerson">
    <ng-container *ngIf="suspectPerson.vehicleList">
      <mat-list-item class="amber-alert-list-item">
        <span mat-line
          >{{ suspectPerson.vehicleList[0]?.licensePlateText }} -
          {{ suspectPerson.vehicleList[0].licensePlateState }}</span
        >
        <span mat-line>License Plate / State</span>
      </mat-list-item>

      <mat-list-item class="amber-alert-list-item">
        <span mat-line
          >{{ suspectPerson.vehicleList[0].make }} - {{ suspectPerson.vehicleList[0].model }}</span
        >
        <span mat-line>Vehicle Make - Model</span>
      </mat-list-item>

      <mat-list-item class="amber-alert-list-item">
        <span mat-line>{{ suspectPerson.vehicleList[0].modelYear }}</span>
        <span mat-line>Vehicle Year</span>
      </mat-list-item>

      <mat-list-item class="amber-alert-list-item">
        <span mat-line>{{ suspectPerson.vehicleList[0].colorPrimary }}</span>
        <span mat-line>Vehicle Color</span>
      </mat-list-item>
    </ng-container>

    <mat-list-item class="amber-alert-list-item">
      <span mat-line>{{ suspectPerson.fullName }} - {{ suspectPerson.age }}</span>
      <span mat-line>Suspect Name - Age</span>
    </mat-list-item>
  </ng-template>

  <ng-template [ngIf]="missingPerson">
    <mat-list-item class="amber-alert-list-item">
      <span mat-line>{{ missingPerson.fullName }} - {{ missingPerson.age }}</span>
      <span mat-line>Missing Child - Age</span>
    </mat-list-item>
  </ng-template>

  <mat-list-item class="amber-alert-list-item">
    <span mat-line>{{ alarm.details['missingFrom'] }}</span>
    <span mat-line>Missing From</span>
  </mat-list-item>

  <mat-list-item class="amber-alert-list-item">
    <span mat-line>{{ alarm.details['lastSeenState'] }}</span>
    <span mat-line>Last Seen State</span>
  </mat-list-item>

  <mat-list-item class="amber-alert-list-item">
    <span mat-line>{{ alarm.details['missingDate'] }}</span>
    <span mat-line>Missing Date</span>
  </mat-list-item>
</mat-list>
